import { useEffect, useState } from 'react';

/**
 * Таб солиход тайлангийн component нь unmount болдог (DeliveryReport зөвхөн
 * идэвхтэй табаа render хийнэ). Тиймээс хайлтын нөхцөл болон үр дүнг модулийн
 * түвшинд хадгалж, буцаж ирэхэд нь сэргээнэ.
 *
 * Зөвхөн санах ойд байх тул хуудсыг refresh хийвэл цэвэрлэгдэнэ. `loading`
 * зэрэг түр зуурын төлвийг хадгалах шаардлагагүй — энгийн useState-ээр авна.
 *
 *   const [range, setRange] = useCachedState('order:range', null);
 */
const cache = new Map();

export const useCachedState = (key, initialValue) => {
  const [value, setValue] = useState(() => (cache.has(key) ? cache.get(key) : initialValue));

  useEffect(() => {
    cache.set(key, value);
  }, [key, value]);

  return [value, setValue];
};
